import new_germany from '../images/newProductPage/languages/DE.png';
import new_spanish from '../images/newProductPage/languages/ES.png';
import new_french from '../images/newProductPage/languages/FR.png';
import new_italy from '../images/newProductPage/languages/IT.png';
import new_niderland from '../images/newProductPage/languages/ND.png';
import new_polish from '../images/newProductPage/languages/PL.png';
import new_portugal from '../images/newProductPage/languages/PR.png';
import new_russia from '../images/newProductPage/languages/RU.png';
import new_england from '../images/newProductPage/languages/UK.png';

import screen1 from '../images/newProductPage/croatian/1.png';
import screen2 from '../images/newProductPage/croatian/2.png';
import screen3 from '../images/newProductPage/croatian/3.png';
import screen4 from '../images/newProductPage/croatian/4.png';
import screen5 from '../images/newProductPage/croatian/5.png';
import screen6 from '../images/newProductPage/croatian/6.png';

import dlaczego1 from '../images/newProductPage/why/dlaczego_1.webp';
import dlaczego2 from '../images/newProductPage/why/dlaczego_2.webp';
import dlaczego3 from '../images/newProductPage/why/dlaczego_3.webp';

import zdjecie2 from '../images/newProductPage/mission/latop_square.png';
import zdjecie3 from '../images/newProductPage/mission/people_square.png';
import zdjecie1 from '../images/newProductPage/mission/women_square.png';

export const bulgarian = {
  navbar: {
    data: [
      { title: 'Поръчай курс', path: '/course' },
      { title: 'Вход', path: '/start' },
      { title: 'Лексикос', path: '/' },
      { title: 'За нас', path: '/about' },
      { title: 'Отзиви', path: '/reviews' },
    ],
  },
  mainPage: {
    product_page: {
      language: 'bg',
      hero: {
        languages: [
          'на английски',
          'на испански',
          'на немски',
          'на холандски',
          'на италиански',
          'на руски',
          'на полски',
          'на френски',
          'на португалски',
        ],
        title: 'Говорете по-уверено,',
        prefix: 'с увереност',
        subtitle:
          'Придобийте езикови умения чрез нашия курс, базиран на примери от реалния живот!',
        buttonText: 'Поръчайте сега!',
      },
      learning: {
        title: 'Как изглежда курсът?',
        config: [
          {
            category: 'Научете езика по най-лесния начин',
            image: screen1,
            descriptions: [
              {
                bold: 'Десетки уроци',
                rest: 'с примери, базирани на ежедневна комуникация.',
              },
              {
                bold: 'Практически фрази',
                rest: 'проектирани от носители на езика.',
              },
              {
                bold: 'Упражнения,',
                rest: 'които ефективно развиват четене, слушане и говорене.',
              },
            ],
          },
          {
            image: screen2,
            category: 'Практически уроци',
            description:
              'Всяко ниво на обучение се състои от десетки уроци, адаптирани към вашите нужди.',
          },
          {
            image: screen3,
            category: 'Задачи',
            description:
              'Нашите упражнения ефективно подкрепят повторението на материала и подобряват паметта.',
          },
          {
            image: screen4,
            category: 'Думи, фрази и изрази',
            description:
              'Всяка лекция съдържа внимателно подбрани изображения, които правят процеса на учене интуитивен.',
          },
        ],
        photoData: [screen1, screen2, screen3, screen4, screen5, screen6],
      },
      languages: {
        languages: [
          { image: new_england, lang: 'Английски' },
          { image: new_french, lang: 'Френски' },
          { image: new_spanish, lang: 'Испански' },
          { image: new_niderland, lang: 'Холандски' },
          { image: new_germany, lang: 'Немски' },
          { image: new_italy, lang: 'Италиански' },
          { image: new_russia, lang: 'Руски' },
          { image: new_portugal, lang: 'Португалски' },
          { image: new_polish, lang: 'Полски' },
        ],
        title: 'Налични езици:',
        description:
          'Подгответе се за следващото си пътуване или добавете езикови умения към автобиографията си.',
      },
      expertSection: {
        title: 'Вашият езиков експерт',
        firstSectionTitle: 'Поддръжка на една ръка разстояние',
        firstSectionDescription:
          'Получавайте пълна поддръжка по време на обучението си!',
        secondSectionTitle: 'Задавайте въпроси и получавайте отговори',
        secondSectionDescription:
          'Всякакви въпроси можете да зададете директно на своя експерт.',
        thirdSectionTitle: 'Индивидуален подход на всяка стъпка',
        thirdSectionDescription:
          'Използването на съветите на езиковия експерт ускорява обучението ви.',
      },
      courseValue: {
        title: 'Получете повече с eLingo',
        subtitle:
          'Не просто езиково обучение – получете пълен достъп до инструменти.',
        buttonText: 'Поръчайте сега!',
        config: [
          {
            title: 'Обучение, адаптирано към вашия начин на живот',
            sections: [
              {
                text: 'Учете, където и когато искате, благодарение на нашата платформа.',
              },
              {
                text: 'Кратките уроци се вписват в ежедневния ви график.',
              },
            ],
          },
          {
            title: 'Мотивация на всяка стъпка',
            sections: [
              {
                text: 'Поддържайте своята мотивация чрез нашата система за проследяване.',
              },
              {
                text: 'Всеки ден учене ви доближава до езикова плавност.',
              },
            ],
          },
          {
            title: 'Пълна гъвкавост и персонализация',
            sections: [
              {
                text: 'Адаптирайте курса към своето ниво и темпо на учене.',
              },
              {
                text: 'Фокусирайте се върху това, което ви интересува най-много.',
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: 'Мисия',
      description: `Вярваме, че езикът формира мост между културите, и нашата мисия е да преодолеем комуникационните бариери и да сближим хората чрез езиково образование.`,
    },
    why: {
      title: 'Защо ние?',
      config: [
        {
          title: 'Иновативни образователни методи',
          image: dlaczego1,
          description:
            'Нашият усъвършенстван и тестван в практиката алгоритъм за обучение адаптира материалите към вашето текущо ниво на знания и го разширява чрез ефективно преподаване.',
        },
        {
          title: 'Широк спектър от езици',
          image: dlaczego2,
          description:
            'Предлагаме курсове по най-популярните световни езици. Това ви позволява да изберете езика, който отговаря на вашите нужди.',
        },
        {
          title: 'Образование по забавен начин',
          image: dlaczego3,
          description:
            'Нашата платформа прави изучаването на езици забавно и приятно преживяване, така че ще бъдете мотивирани да учите езици.',
        },
      ],
    },
    mission: {
      config: [
        {
          title: 'Персонализация и достъпност',
          description:
            'Нашият ефективен алгоритъм за машинно обучение постоянно работи, за да предостави подходящи материали на ниво за всеки индивид. Лексикос позволява на учащите да откриват модели самостоятелно, без да се фокусират върху правилата на езика – точно както сте научили майчиния си език в детството.',
          image: zdjecie1,
        },
        {
          title: 'Комбинация от технология и наука',
          description:
            'Лексикос използва смела комбинация от технология и наука, за да стимулира ума към действие. Повтарянето на безброй списъци с думи и изрази е скучно, и вашият мозък го знае. Нашият метод е вълнуващ и ефективен, принуждавайки ви да използвате придобитите знания по различни начини в конкретни моменти - вашият мозък ще оцени това решение!',
          image: zdjecie2,
        },
        {
          title: 'Общност и ценности',
          description:
            'Езиците помагат на хората да се ангажират. Изучаването на езици улеснява разбирането. Общността на Лексикос събира хора от цял свят. Ние сме амбициозни и винаги разширяваме границите. Вярваме, че изучаването на езици може да бъде забавно и сме любопитни да изследваме нови култури чрез езика.',
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: 'https://nyelvfejlesztesi-kozpont.eu/',
      title: 'Интересувате се от курса? ',
      title1: 'Искате ли повече информация?',
      subtitle: 'Оставете телефонния си номер - ще ви се обадим.',
      subtitle1: 'Ако вече имате акаунт, моля, попълнете следните полета:',
      button1: 'Име и фамилия',
      button2: 'Телефонен номер',
      button3: 'Имейл',
      buttonSub: 'Изпрати',
      checkOne:
        'С изпращането на този формуляр приемам условията и декларирам, че съм прочел следното',
      checkOneTwo: 'следното',
      checkTwo: 'Съгласявам се да бъда контактуван за маркетингови цели',
      textOne: 'Моля, бъдете информирани, че',
      textTwo:
        'Администратор на вашите лични данни е EOU Sp. z o.o., със седалище във Варшава, ул. Млинарска 42 / 115, 01-171, регистрирана в регистъра на предприемачите, поддържан от районния съд на Варшава под KRS5273057993, REGON: 525396900, NIP5273057993. Вашите лични данни ще бъдат обработвани във връзка със запитването чрез формуляра за контакт или изпълнението на сключения договор. Като се свържете с нас, вие доброволно се съгласявате с обработката на вашите лични данни за горепосочените цели. Имате право на достъп, коригиране, изтриване или ограничаване на обработката на вашите данни, да възразите срещу обработката и да прехвърляте данните. Имате право и да оттеглите съгласието си по всяко време, но оттеглянето на съгласието не засяга законосъобразността на обработката, основана на съгласие преди неговото оттегляне. Имате право и да подадете жалба до надзорния орган. Предоставянето на данни е доброволно, но може да бъде необходимо за отговор на запитване или изпълнение на договор. Личните данни ще се съхраняват за периода, необходим за горепосочените цели, но не по-дълго от периода на давност на исковете съгласно общото право. Моля, прочетете внимателно политиката за поверителност',
      buttonMore: 'Прочетете повече',
      buttonLess: 'Прочетете по-малко',
      subOne: 'условия',
      subTwo: 'и правила за поверителност.',
      buttonTXT: 'Благодаря',
      rulesLink: '/Regulations_EN.pdf',
      privacyLink: '/Privacy_EN.pdf',
      product: 'eb',
      market: 'bg',
      send_to_url: 'https://crm.eou-edu.eu/api/v1/cms/create_order',
      utm_source: 'Platform_Lexicos',
      product_variant: 'en-bg',
      server_link: 'https://cms.eou-edu.eu/integration/lead-from-landing',
      currency: 'bgn',
      price: 170,
    },
  },
  reviews: {
    language: 'bg',
    title: 'Мнения за eLingo',
    subtitle:
      'Твоето мнение има значение - отзивите за eLingo ни помагат да развиваме платформата в съответствие с нуждите на потребителите.',
    contentPlaceholder: 'Започни да пишеш',
    submitButton: 'Изпрати',
    thankYouText:
      'Благодарим ви, че споделяте опита си и заедно с нас създавате ефективен инструмент за изучаване на езици!',
  },
  footer: {
    title: 'Присъединете се към нас на:',
    phoneInfo: 'Нашата линия за продажба → ',
    phoneNo: '+359 2 905 1074',
    privacy: 'Поверителност',
    privacyLink: '/Privacy_BG.pdf',
    rules: 'Условия за ползване',
    rulesLink: '/Regulations_BG.pdf',
  },
};
